import React, { Component } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Colors } from 'modules/theme';
import H1 from 'components/H1';
import H2 from 'components/H2';
import H3 from 'components/H3';
import H4 from 'components/H4';
import H5 from 'components/H5';
import Col from 'components/Col';
import Row from 'components/Row';
import DatePickerComponent from 'components/Datepicker/DatePickerComponent';
import Modal from 'components/Modal';
import LineGray from 'components/Line';
import Loader from 'components/Loader';
import Input from 'components/InputText';
import ButtonText from 'components/ButtonText';
import Icon from 'components/Icon';
import ListEmpty from 'components/ListEmpty';
import BG from 'components/BG';
import QuickStats from 'components/QuickStats';
import domtoimage from 'dom-to-image';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { Tooltip as TooltipReact } from 'react-tooltip';
import { CONSUMPTION_INTERVAL_GROUPS, getIntervalLabel } from 'constants/consumptionIntervals';
import {
  getReverseOsmosisCurrentState,
  getReverseOsmosisConsumption,
  getTotalConsumptionReverseOsmosis,
  changeMembranes,
  getReverseOsmosisTds,
  getReverseOsmosisWaste,
  reverseOsmosisSetInitialState,
  generateReverseOsmosisCsv,
  getTotalConsumptionRo,
  getTotalConsumptionCartridgeRo,
  replaceReverseOsmosisCartridges,
  getReverseOsmosisBypass,
  getReverseOsmosisCurrentBypass,
  getReverseOsmosisCurrentPressure,
  getReverseOsmosisCurrentTemperature,
} from 'actions/index';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import FlowVolumeChart from './FlowVolumeChart';
import RoFlowVolumeChart, { RoFlowLegend } from './RoFlowVolumeChart';
import RoMetricLineChart from './RoMetricLineChart';
import {
  ChartMeta,
  ChartSection,
  ChartViewport,
  ChartViewportFull,
  DateRangeButton,
  IntervalBadge,
  LastUpdatedBadge,
  LastUpdatedDot,
  LastUpdatedLabel,
  LastUpdatedValue,
  StatCard,
  StatLabel,
  StatsRow,
  StatUnit,
  StatValue,
} from './flowVolume.styles';

import { ReportRO } from './ReportRO';
import { ModalDatePicker } from './ModalDatePicker';
import ModalCsvFiles from './ModalCsvFiles';

const Container = styled.div`
  margin: 0px;
  position: relative;
  overflow-x: hidden;
  min-height: 100%;
`;

const GraphContainer = styled.div`
  width: 100%;
  position: relative;
  min-height: ${props => props.height}px;
  max-height: ${props => (props.maxHeight ? props.maxHeight : 'auto')};
  display: ${props => props.display ?? 'inherit'};
  justify-content: ${props => props.justifyContent ?? 'center'};
  align-items: ${props => props.alignItems ?? 'center'};
  flex-direction: ${props => props.flexDirection ?? 'row'};
  overflow: ${props => props.overflow ?? 'visible'};
`;
// Evaluated per mount, not at module load: a module-level `new Date()` freezes
// at bundle evaluation, so the chart kept asking for data up to whenever the app
// was opened while the total widgets asked for "now", and the two disagreed by
// everything consumed in between.
const getStartDate = () =>
  moment()
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    .add(-7, 'days')
    .toDate();

const getEndDate = () => moment().toDate();

const getStartDateTds = () =>
  moment()
    .add(-1, 'days')
    .toDate();

const RO_PANEL_HEIGHT = 540;

class RO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartridgesChangeDate: '',
      membraneChangeDate: '',
      modalMembrane: false,
      modalCartridges: false,
      description: '',
      generatePDF: false,
      downloadPDF: false,
      catridgeSelectedId: null,
      catridgeSelectedObjet: null,
      showConfiguration: false,
      modalViewInstructions: false,
      modalDatePickerCsv: false,
      modalDatePickerConsumption: false,
      modalDatePickerWaste: false,
      modalDatePickerTds: false,
      carbonCapacity: 0,
      datePickerFromConsumption: getStartDate(),
      datePickerToConsumption: getEndDate(),
      datePickerFromCsv: getStartDate(),
      datePickerToCsv: getEndDate(),
      datePickerFromTds: getStartDateTds(),
      datePickerToTds: getEndDate(),
      datePickerFromWaste: getStartDate(),
      datePickerToWaste: getEndDate(),
      rangeConsumption: 'days',
      possibleDayRangesConsumption: ['days'],
      rangeWaste: 'days',
      possibleDayRangesWaste: ['days'],
      rangeTds: 'hours',
      possibleDayRangesTds: ['hours', 'days'],
      csvType: 1,
      csvTypeString: 'raw_data',
      modalDeviceId: false,
      new_device_id: '',
      datePickerFromReport: getStartDate(),
      datePickerToReport: getEndDate(),
      modalDatePickerReport: false,
      modalDatePickerBypass: false,
      modalBypass: false,
      datePickerFromBypass: getStartDate(),
      datePickerToBypass: getEndDate(),
      consumptionInterval: '1d',
      bypassInterval: '1d',
      tdsInterval: '1h',
      wasteInterval: '1d',
    };
  }

  componentDidMount() {
    const {
      location: { ReverseOsmosisFilterHead },
      reverseOsmosisSetInitialState,
    } = this.props;
    reverseOsmosisSetInitialState();
    const { installed_date, last_membrane_change_date } = ReverseOsmosisFilterHead;

    if (moment(getStartDate()) < moment(installed_date)) {
      // Sync date pickers from installation dates before first fetch
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState(
        {
          datePickerFromConsumption: moment(last_membrane_change_date).toDate(),
          datePickerFromCsv: moment(installed_date).toDate(),
          datePickerFromTds: moment(installed_date).toDate(),
          datePickerFromWaste: moment(installed_date).toDate(),
        },
        () => this.getInitialData(),
      );
    } else {
      this.getInitialData();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.ro_for_pfd && this.props.ro_for_pfd) {
      this.putDataInPdf();
    }

    // Add code to update last_updated timestamp in parent
    const {
      reverseOsmosisConsumption,
      reverseOsmosisConsumptionLoading,
      updateLastUpdated,
      reverseOsmosisCurrentState,
      reverseOsmosisCurrentStateLoading,
      updateTdsValue,
      setDeviceDisconnected,
    } = this.props;

    // Check if consumption data loading has completed
    if (
      prevProps.reverseOsmosisConsumptionLoading &&
      !reverseOsmosisConsumptionLoading &&
      reverseOsmosisConsumption
    ) {
      // Check if device is disconnected (last_updated is null)
      if (reverseOsmosisConsumption.last_updated === null && setDeviceDisconnected) {
        setDeviceDisconnected(true);
      }
      // Otherwise update the last updated timestamp if it exists
      else if (reverseOsmosisConsumption.last_updated && updateLastUpdated) {
        updateLastUpdated(reverseOsmosisConsumption.last_updated);
        // Reset disconnected state if it was previously set
        if (setDeviceDisconnected) {
          setDeviceDisconnected(false);
        }
      }
    }

    // Update TDS value
    if (
      prevProps.reverseOsmosisCurrentStateLoading &&
      !reverseOsmosisCurrentStateLoading &&
      reverseOsmosisCurrentState &&
      updateTdsValue
    ) {
      updateTdsValue(reverseOsmosisCurrentState.tds_value);
    }
  }

  putDataInPdf = async () => {
    try {
      const {
        location: { id: location_id },
        fetchAllAlerts,
      } = this.props;
      await fetchAllAlerts({ location_id });

      let totalGaloonsChart = document.getElementById('totalGaloonsChart');
      let averageChart = document.getElementById('averageChart');
      let wasteChart = document.getElementById('wasteChart');
      let exhaustionChart = document.getElementById('exhaustionChart');

      totalGaloonsChart = totalGaloonsChart && (await domtoimage.toPng(totalGaloonsChart));
      averageChart = averageChart && (await domtoimage.toPng(averageChart));
      wasteChart = wasteChart && (await domtoimage.toPng(wasteChart));
      exhaustionChart = exhaustionChart && (await domtoimage.toPng(exhaustionChart));

      this.setState({
        totalGaloonsChart,
        averageChart,
        wasteChart,
        exhaustionChart,
        downloadPDF: true,
      });
    } catch (error) {
      this.setState({ generatePDF: false });
      console.log(error);
    }
  };

  getInitialData = () => {
    const {
      location: { ReverseOsmosisFilterHead },
      getReverseOsmosisCurrentState,
      getReverseOsmosisConsumption,
      getReverseOsmosisTds,
      getReverseOsmosisWaste,
      getTotalConsumptionRo,
      getTotalConsumptionCartridgeRo,
      getReverseOsmosisCurrentBypass,
      getReverseOsmosisCurrentPressure,
      getReverseOsmosisCurrentTemperature,
      setLastUpdatedLoading,
      setTdsLoading,
    } = this.props;

    const {
      id: reverse_osmosis_filter_head_id,
      FlowMeterOfROFilters,
      device_id,
      last_membrane_change_date,
    } = ReverseOsmosisFilterHead;

    if (device_id) {
      const {
        datePickerFromConsumption,
        datePickerToConsumption,
        datePickerFromTds,
        datePickerToTds,
        datePickerFromWaste,
        datePickerToWaste,
        rangeConsumption,
        rangeWaste,
        rangeTds,
      } = this.state;

      // Set loading state in parent component
      if (setLastUpdatedLoading) {
        setLastUpdatedLoading();
      }

      // Set TDS loading state in parent component
      if (setTdsLoading) {
        setTdsLoading();
      }

      const catridgeSelectedObjet = FlowMeterOfROFilters[0];
      if (catridgeSelectedObjet) {
        const carbonCapacity = this.calculePreCarbonCapacity();

        this.setState({
          catridgeSelectedId: catridgeSelectedObjet.SpotsReverseOsmosisFilter.Catridge.id,
          catridgeSelectedObjet,
          carbonCapacity,
        });

        getReverseOsmosisCurrentPressure({ device_id });

        getReverseOsmosisCurrentTemperature({ device_id });

        if (catridgeSelectedObjet.last_replaced) {
          getTotalConsumptionCartridgeRo({
            device_id,
            from: catridgeSelectedObjet.last_replaced,
            spot_id: catridgeSelectedObjet.spot_reverse_osmosis_filter_id,
            reverse_osmosis_filter_head_id,
          });
        }
      }

      getReverseOsmosisCurrentBypass(device_id);

      getTotalConsumptionRo({
        device_id,
        last_membrane_change_date,
        last_catridge_change_date: catridgeSelectedObjet.last_replaced,
      });

      getReverseOsmosisCurrentState(device_id);

      getReverseOsmosisConsumption({
        device_id,
        from: datePickerFromConsumption,
        to: datePickerToConsumption,
        range: rangeConsumption,
        interval: this.state.consumptionInterval,
      });

      getReverseOsmosisTds({
        device_id,
        from: datePickerFromTds,
        to: datePickerToTds,
        range: rangeTds,
        interval: this.state.tdsInterval,
      });

      getReverseOsmosisWaste({
        device_id,
        from: datePickerFromWaste,
        to: datePickerToWaste,
        range: rangeWaste,
        interval: this.state.wasteInterval,
      });
    }
  };

  calculePreCarbonCapacity = () => {
    const {
      location: {
        ReverseOsmosisFilterHead: { chlorine_or_chloramine, FlowMeterOfROFilters },
      },
    } = this.props;

    // Include only Pre-carbon filters (PRE filters), excluding POST filters
    const preCarbonFilters = FlowMeterOfROFilters.filter(
      ({ SpotsReverseOsmosisFilter }) => SpotsReverseOsmosisFilter.position === 'Pre-carbon filter',
    );

    const totalCapacity = preCarbonFilters.reduce((total, { SpotsReverseOsmosisFilter }) => {
      const { Catridge } = SpotsReverseOsmosisFilter;
      return total + this.calculeCatridgeCapacity(Catridge, chlorine_or_chloramine);
    }, 0);

    return totalCapacity;
  };

  calculeCatridgeCapacity = (catridge, chlorine_or_chloramine) => {
    const capacitySelected =
      chlorine_or_chloramine === 'Chlorine'
        ? catridge.chlorine_capacity
        : catridge.chloramine_capacity;

    return catridge.scale_control_capacity
      ? capacitySelected && catridge.scale_control_capacity > capacitySelected
        ? capacitySelected
        : catridge.scale_control_capacity
      : capacitySelected;
  };

  cartidgeOnChange = evt => {
    const {
      location: {
        ReverseOsmosisFilterHead: {
          id: reverse_osmosis_filter_head_id,
          FlowMeterOfROFilters,
          device_id,
        },
      },
      getTotalConsumptionCartridgeRo,
    } = this.props;

    const catridgeSelectedObjet = FlowMeterOfROFilters.find(
      wf => wf.id === parseInt(evt.target.value, 10),
    );

    const {
      last_replaced,
      /* SpotsReverseOsmosisFilter : {  Catridge }, */
    } = catridgeSelectedObjet;

    if (last_replaced) {
      getTotalConsumptionCartridgeRo({
        device_id,
        from: catridgeSelectedObjet.last_replaced,
        spot_id: catridgeSelectedObjet.spot_reverse_osmosis_filter_id,
        reverse_osmosis_filter_head_id,
      });
    }

    this.setState({
      catridgeSelectedId: evt.target.value,
      catridgeSelectedObjet,
    });
  };

  switchModal = name => {
    const isVisible = this.state[name];
    this.setState({ [name]: !isVisible });

    // If we're opening the bypass modal, load the bypass data
    if (name === 'modalBypass' && !isVisible) {
      this.calculeReverseOsmosisBypass();
    }
  };

  handleChangeDeviceId = evt => {
    this.setState({ new_device_id: evt.target.value });
  };

  handleDate = (value, key) => {
    this.setState({ [key]: value });
  };

  replaceReverseOsmosisCartridgesFunc = () => {
    const {
      location: {
        ReverseOsmosisFilterHead: { id: reverse_osmosis_filter_head_id },
      },
      replaceReverseOsmosisCartridges,
    } = this.props;
    const { cartridgesChangeDate } = this.state;
    const cartridgesChangeDateUTC = moment(cartridgesChangeDate)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');

    replaceReverseOsmosisCartridges({
      reverse_osmosis_filter_head_id,
      new_date: cartridgesChangeDateUTC,
    });
  };

  possibleRanges = daysRange => {
    const possibleDayRanges = [];
    if (daysRange <= 1) possibleDayRanges.push('hours');
    if (daysRange >= 1 && daysRange < 15) possibleDayRanges.push('days');
    if (daysRange >= 14 && daysRange < 105) possibleDayRanges.push('weeks');
    if (daysRange >= 30 && daysRange < 450) possibleDayRanges.push('months');
    if (daysRange >= 365) possibleDayRanges.push('years');

    return possibleDayRanges;
  };

  generateReverseOsmosisCsv = email => {
    const {
      generateReverseOsmosisCsv,
      location: {
        id,
        ReverseOsmosisFilterHead: { device_id },
      },
    } = this.props;
    const { csvTypeString } = this.state;

    const { datePickerFromCsv: from, datePickerToCsv: to } = this.state;
    generateReverseOsmosisCsv({
      device_id,
      location_id: id,
      from,
      to,
      csvContains: csvTypeString,
      email,
    });
  };

  changeCsvType = (csvType, nro) => {
    const csvTypes = ['raw_data', 'calculated_data', 'all_data'];

    this.setState({ [csvType]: nro, csvTypeString: csvTypes[nro - 1] });
  };

  calculeReverseOsmosisConsumption = (range, ro_for_pfd) => {
    const {
      getReverseOsmosisConsumption,
      location: {
        ReverseOsmosisFilterHead: { device_id },
      },
    } = this.props;
    const {
      datePickerFromConsumption: from,
      datePickerToConsumption: to,
      consumptionInterval,
    } = this.state;

    const currentRange = range || 'days';
    getReverseOsmosisConsumption({
      device_id,
      from,
      to,
      interval: consumptionInterval,
      range: currentRange,
      ro_for_pfd,
    });
    this.setState({ rangeConsumption: currentRange });
  };

  calculeReverseOsmosisTds = (range, ro_for_pfd) => {
    const {
      getReverseOsmosisTds,
      location: {
        ReverseOsmosisFilterHead: { device_id },
      },
    } = this.props;
    const { datePickerFromTds: from, datePickerToTds: to, tdsInterval } = this.state;

    const currentRange = range || 'days';
    getReverseOsmosisTds({
      device_id,
      from,
      to,
      interval: tdsInterval,
      range: currentRange,
      ro_for_pfd,
    });
    this.setState({ rangeTds: currentRange });
  };

  calculeReverseOsmosisWaste = (range, ro_for_pfd) => {
    const {
      getReverseOsmosisWaste,
      location: {
        ReverseOsmosisFilterHead: { device_id },
      },
    } = this.props;
    const { datePickerFromWaste: from, datePickerToWaste: to, wasteInterval } = this.state;

    const currentRange = range || 'days';
    getReverseOsmosisWaste({
      device_id,
      from,
      to,
      interval: wasteInterval,
      range: currentRange,
      ro_for_pfd,
    });
    this.setState({ rangeWaste: currentRange });
  };

  generateReport = async () => {
    try {
      const { datePickerFromReport, datePickerToReport } = this.state;
      this.setState(
        {
          datePickerFromConsumption: datePickerFromReport,
          datePickerToConsumption: datePickerToReport,
          datePickerFromTds: datePickerFromReport,
          datePickerToTds: datePickerToReport,
          datePickerFromWaste: datePickerFromReport,
          datePickerToWaste: datePickerToReport,
          generatePDF: true,
        },
        () => {
          this.calculeReverseOsmosisConsumption(false, true);
          this.calculeReverseOsmosisWaste(false, true);
          this.calculeReverseOsmosisTds(false, true);
        },
      );
    } catch (error) {
      console.log(error);
      this.setState({ generatePDF: false });
    }
  };

  calculeReverseOsmosisBypass = () => {
    const {
      getReverseOsmosisBypass,
      location: {
        ReverseOsmosisFilterHead: { device_id, installed_date },
      },
    } = this.props;
    const { datePickerFromBypass: from, datePickerToBypass: to, bypassInterval } = this.state;

    getReverseOsmosisBypass({
      device_id,
      from,
      to,
      installed_date,
      interval: bypassInterval,
    });
  };

  calculeDaysRange = (from, to) => {
    const possibleDayRanges = [];
    const fromDate = moment(from);
    const toDate = moment(to);
    const daysRange = toDate.diff(fromDate, 'days');

    // The maximum of days chosen in each condition is the equivalent of the maximum of 15 bars on the chart
    if (daysRange <= 1) possibleDayRanges.push('hours');
    if (daysRange >= 1 && daysRange < 15) possibleDayRanges.push('days');
    if (daysRange >= 14 && daysRange < 105) possibleDayRanges.push('weeks');
    if (daysRange >= 30 && daysRange < 450) possibleDayRanges.push('months');
    if (daysRange >= 365) possibleDayRanges.push('years');
    return possibleDayRanges;
  };

  renderBypassConsumptions = () => {
    const {
      reverseOsmosisBypass: { consumption = [], total_flow = 0, last_updated },
      reverseOsmosisBypassLoading,
      location: {
        ReverseOsmosisFilterHead: { device_id },
      },
    } = this.props;
    const { datePickerFromBypass, datePickerToBypass, bypassInterval } = this.state;

    const displayConsumption = (consumption || []).map(item => ({
      ...item,
      gal: item.gal >= 1 ? item.gal : 0,
    }));

    const displayTotalFlow =
      total_flow && !Number.isNaN(parseFloat(total_flow)) && parseFloat(total_flow) > 0
        ? Math.round(parseFloat(total_flow))
        : null;

    return (
      <GraphContainer height={540}>
        <Col style={{ width: '100%', alignItems: 'stretch' }}>
          <Row
            justifyContent="space-between"
            alignItems="center"
            style={{ width: '100%', marginBottom: 20 }}
          >
            <H2
              style={{
                margin: 0,
                fontWeight: 600,
                fontSize: '24px',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              Bypass Flow
            </H2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <IntervalBadge>{getIntervalLabel(bypassInterval)}</IntervalBadge>
              <DateRangeButton
                type="button"
                onClick={() => this.switchModal('modalDatePickerBypass')}
              >
                {moment(datePickerFromBypass).format('MM/DD/YYYY')} –{' '}
                {moment(datePickerToBypass).format('MM/DD/YYYY')}
                <Icon name="calendar-alt" color={Colors.lightBlue} fontSize={14} />
              </DateRangeButton>
            </div>
          </Row>

          <ChartSection style={{ alignItems: 'stretch' }}>
            {!device_id ? (
              <Col style={{ height: 300 }} justifyContent="center">
                <ListEmpty message="Installation Not Complete" />
              </Col>
            ) : (
              <ChartViewportFull>
                <FlowVolumeChart
                  id="roBypassFlowChart"
                  dataChart={displayConsumption}
                  consumption={displayConsumption}
                  loading={reverseOsmosisBypassLoading}
                  pressureLoading={false}
                  showPressure={false}
                />
              </ChartViewportFull>
            )}
            {last_updated && !reverseOsmosisBypassLoading && (
              <ChartMeta>
                <LastUpdatedBadge>
                  <LastUpdatedLabel>Updated</LastUpdatedLabel>
                  <LastUpdatedValue>{moment.unix(last_updated).format('h:mm A')}</LastUpdatedValue>
                  <LastUpdatedDot>·</LastUpdatedDot>
                  <LastUpdatedValue>
                    {moment.unix(last_updated).format('MMM D, YYYY')}
                  </LastUpdatedValue>
                </LastUpdatedBadge>
              </ChartMeta>
            )}
          </ChartSection>

          <StatsRow style={{ gridTemplateColumns: '1fr', maxWidth: '320px' }}>
            <StatCard>
              <StatLabel>Total Flow</StatLabel>
              <div style={{ marginTop: 10 }}>
                {reverseOsmosisBypassLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Loader size={15} />
                    <H5 color={Colors.gray8} style={{ marginLeft: 10, margin: 0 }}>
                      Loading...
                    </H5>
                  </div>
                ) : (
                  <>
                    <H5 weight="bold" color={Colors.lightBlue} marginTop={5} style={{ margin: 0 }}>
                      since installation
                    </H5>
                    <div style={{ marginTop: 8 }}>
                      <StatValue>{displayTotalFlow == null ? 'N/A' : displayTotalFlow}</StatValue>
                      {displayTotalFlow != null && <StatUnit>gal</StatUnit>}
                    </div>
                  </>
                )}
              </div>
            </StatCard>
          </StatsRow>
        </Col>
      </GraphContainer>
    );
  };

  renderConfigurationModal = () => {
    const { showConfiguration } = this.state;
    const {
      location: {
        ReverseOsmosisFilterHead: {
          ReverseOsmosisFilterConfiguration,
          chlorine_or_chloramine,
          FlowMeterOfROFilters,
        },
      },
    } = this.props;
    const { name } = ReverseOsmosisFilterConfiguration;

    return (
      <Modal
        title="Configuration"
        onClose={() => this.switchModal('showConfiguration')}
        isVisible={showConfiguration}
      >
        <H4 lineHeight={2} textAlign="left" color={Colors.gray8} weight={325} style={{ margin: 0 }}>
          Configuration name
        </H4>
        <H4 lineHeight={2} color={Colors.black} weight={500} style={{ marginTop: 5 }}>
          {name}
        </H4>
        <H4 lineHeight={2} color={Colors.black} weight={500} style={{ marginTop: 5 }}>
          <Icon name="check-circle" color={Colors.lightBlue} customStyle={{ marginRight: 5 }} />
          {chlorine_or_chloramine}
        </H4>

        {FlowMeterOfROFilters.map(({ SpotsReverseOsmosisFilter, type, name }) => {
          const { ReverseOsmosisFilter, Catridge } = SpotsReverseOsmosisFilter;
          return (
            <>
              <H4 lineHeight={2} color={Colors.lightBlue} weight="bold" style={{ marginTop: 5 }}>
                {ReverseOsmosisFilter.name}
              </H4>

              <Row alignItems="left" lg={100} md={100} sm={100} xs={100}>
                <Col lg={30} md={30} sm={30} xs={30} alignItems="left">
                  <H4 lineHeight={2} weight="bold" style={{ marginTop: 5 }}>
                    {SpotsReverseOsmosisFilter.position} -{Catridge.name}
                  </H4>
                </Col>
                <Col lg={70} md={70} sm={70} xs={70} alignItems="left">
                  <H4 lineHeight={2} weight="bold" style={{ marginTop: 5 }}>
                    Capacity:{' '}
                    {this.calculeCatridgeCapacity(
                      Catridge,
                      chlorine_or_chloramine,
                    ).toLocaleString()}{' '}
                    gal
                  </H4>
                </Col>
                <>
                  <Col lg={30} md={30} sm={30} xs={30} alignItems="left">
                    <H4
                      lineHeight={2}
                      textAlign="left"
                      color={Colors.gray8}
                      weight={325}
                      style={{ margin: 0 }}
                    >
                      Type
                    </H4>

                    <H4 lineHeight={2} weight="bold" style={{ marginTop: 5 }}>
                      {type}
                    </H4>
                  </Col>
                  <Col lg={70} md={70} sm={70} xs={70} alignItems="left">
                    <H4
                      lineHeight={2}
                      textAlign="left"
                      color={Colors.gray8}
                      weight={325}
                      style={{ margin: 0 }}
                    >
                      Name
                    </H4>
                    <H4 lineHeight={2} weight="bold" style={{ marginTop: 5 }}>
                      {name}
                    </H4>
                  </Col>

                  {Catridge.photo && (
                    <Col alignItems="start" xs={100} md={100} sm={100} lg={100}>
                      <img width={200} src={Catridge.photo} alt="catridge_photo" />
                    </Col>
                  )}
                  <LineGray />
                </>
              </Row>
            </>
          );
        })}
      </Modal>
    );
  };

  renderActiveShape = props => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload } = props;
    return (
      <g>
        <text
          x={cx}
          y={cy - 8}
          dy={8}
          textAnchor="middle"
          fontFamily="Gotham, Sans Serif"
          fontSize={25}
          fill={Colors.black}
        >
          {payload.value}%
        </text>
        <text
          x={cx}
          y={cy + 15}
          textAnchor="middle"
          fontFamily="Gotham, Sans Serif"
          fontSize={14}
          fill={Colors.gray8}
        >
          remaining
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
      </g>
    );
  };

  renderPressure = () => {
    const iconTime = <Icon name="weight" color={Colors.yellow} fontSize={22} />;
    if (this.props.data.length !== 0) {
      return (
        <Col lg={50} md={50} sm={100} xs={100}>
          <H2 marginBottom={10} textAlign="center">
            Pressure Differential
          </H2>

          <Row>
            <Col lg={50} md={50} sm={50} xs={50}>
              <H4>A 145689</H4>
            </Col>
            <Col lg={50} md={50} sm={50} xs={50}>
              <Row justifyContent="center">
                {iconTime}
                <H4 color={Colors.blue} marginLeft={5} marginRight={5}>
                  45
                </H4>
                <H4>PSI</H4>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col lg={50} md={50} sm={50} xs={50}>
              <H4>A 145689</H4>
            </Col>
            <Col lg={50} md={50} sm={50} xs={50}>
              <Row justifyContent="center">
                {iconTime}
                <H4 color={Colors.blue} marginLeft={5} marginRight={5}>
                  45
                </H4>
                <H4>PSI</H4>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col lg={50} md={50} sm={50} xs={50}>
              <H4>A 145689</H4>
            </Col>
            <Col lg={50} md={50} sm={50} xs={50}>
              <Row justifyContent="center">
                {iconTime}
                <H4 color={Colors.blue} marginLeft={5} marginRight={5}>
                  45
                </H4>
                <H4>PSI</H4>
              </Row>
            </Col>
          </Row>
        </Col>
      );
    }
    return (
      <Col lg={50} md={50} sm={100} xs={100}>
        <H2 lineHeight="1" textAlign="center" style={{ margin: 10 }}>
          Pressure
        </H2>
        <H1 lineHeight="0" color={Colors.blue}>
          N/A
        </H1>
      </Col>
    );
  };

  renderReverseOsmosisConsumptions = () => {
    const {
      reverseOsmosisConsumption: { consumption, last_updated, permeate_flow, inlet_flow },
      reverseOsmosisConsumptionLoading,
      location: {
        ReverseOsmosisFilterHead: { device_id },
      },
      totalConsumptionRoLoading,
      totalConsumptionRo,
    } = this.props;

    const { datePickerFromConsumption, datePickerToConsumption, consumptionInterval } = this.state;
    const totalPermeateFlow =
      permeate_flow ?? (consumption || []).reduce((acc, curr) => acc + (Number(curr.gal) || 0), 0);
    const totalInletFlow =
      inlet_flow ??
      (consumption || []).reduce((acc, curr) => acc + (Number(curr.galInlet) || 0), 0);
    const periodFlowStatsLoading = reverseOsmosisConsumptionLoading;
    const totalPermeateFlowLoading = reverseOsmosisConsumptionLoading || totalConsumptionRoLoading;

    return (
      <GraphContainer
        height={RO_PANEL_HEIGHT}
        style={{ display: 'flex', flexDirection: 'column', overflow: 'visible' }}
      >
        <Col
          style={{
            width: '100%',
            alignItems: 'stretch',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
          }}
        >
          <Row
            justifyContent="space-between"
            alignItems="center"
            style={{ width: '100%', marginBottom: 12, flexShrink: 0 }}
          >
            <H2
              style={{
                margin: 0,
                fontWeight: 600,
                fontSize: '24px',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              Flow Volume
            </H2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <IntervalBadge>{getIntervalLabel(consumptionInterval)}</IntervalBadge>
              <DateRangeButton
                type="button"
                onClick={() => this.switchModal('modalDatePickerConsumption')}
              >
                {moment(datePickerFromConsumption).format('MM/DD/YYYY')} –{' '}
                {moment(datePickerToConsumption).format('MM/DD/YYYY')}
                <Icon name="calendar-alt" color={Colors.lightBlue} fontSize={14} />
              </DateRangeButton>
              <div style={{ marginLeft: 10 }}>
                <a
                  data-tooltip-id="ro-flow-volume-tooltip"
                  data-tooltip-html="<strong>Reverse Osmosis Flow Volume</strong><br><strong>Inlet Flow:</strong> Water entering the RO system.<br><strong>Permeate Flow:</strong> Clean water exiting the RO system."
                >
                  <Icon name="info-circle" color={Colors.gray8} fontSize={16} />
                </a>
                <TooltipReact id="ro-flow-volume-tooltip" />
              </div>
            </div>
          </Row>

          <div
            style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8, flexShrink: 0 }}
          >
            <RoFlowLegend />
          </div>

          <ChartSection style={{ flex: '1 1 auto', minHeight: 0, width: '100%' }}>
            {!device_id ? (
              <Col style={{ height: 250 }} justifyContent="center">
                <ListEmpty message="Installation Not Complete" />
              </Col>
            ) : (
              <ChartViewport style={{ height: 250, maxWidth: 'none' }}>
                <RoFlowVolumeChart
                  id="roTotalGallonsChart"
                  data={consumption}
                  loading={reverseOsmosisConsumptionLoading}
                />
              </ChartViewport>
            )}
            {last_updated && !reverseOsmosisConsumptionLoading && (
              <ChartMeta>
                <LastUpdatedBadge>
                  <LastUpdatedLabel>Updated</LastUpdatedLabel>
                  <LastUpdatedValue>{moment.unix(last_updated).format('h:mm A')}</LastUpdatedValue>
                  <LastUpdatedDot>·</LastUpdatedDot>
                  <LastUpdatedValue>
                    {moment.unix(last_updated).format('MMM D, YYYY')}
                  </LastUpdatedValue>
                </LastUpdatedBadge>
              </ChartMeta>
            )}
          </ChartSection>

          <StatsRow
            style={{
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              maxWidth: 'none',
              marginTop: 8,
            }}
          >
            <StatCard style={{ minHeight: 88, padding: '12px 14px' }}>
              <StatLabel>Permeate Flow</StatLabel>
              <div style={{ marginTop: 10 }}>
                {periodFlowStatsLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Loader size={15} />
                    <H5 color={Colors.gray8} style={{ marginLeft: 10, margin: 0 }}>
                      Loading...
                    </H5>
                  </div>
                ) : (
                  <>
                    <H5 color={Colors.gray8} style={{ margin: '0 0 8px', fontSize: 12 }}>
                      Selected period
                    </H5>
                    <StatValue>
                      {totalPermeateFlow === 0
                        ? 'N/A'
                        : Math.round(totalPermeateFlow).toLocaleString()}
                    </StatValue>
                    {totalPermeateFlow !== 0 && <StatUnit>gal</StatUnit>}
                  </>
                )}
              </div>
            </StatCard>

            <StatCard style={{ minHeight: 88, padding: '12px 14px' }}>
              <StatLabel>Inlet Flow</StatLabel>
              <div style={{ marginTop: 10 }}>
                {periodFlowStatsLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Loader size={15} />
                    <H5 color={Colors.gray8} style={{ marginLeft: 10, margin: 0 }}>
                      Loading...
                    </H5>
                  </div>
                ) : (
                  <>
                    <H5 color={Colors.gray8} style={{ margin: '0 0 8px', fontSize: 12 }}>
                      Selected period
                    </H5>
                    <StatValue>
                      {totalInletFlow === 0 ? 'N/A' : Math.round(totalInletFlow).toLocaleString()}
                    </StatValue>
                    {totalInletFlow !== 0 && <StatUnit>gal</StatUnit>}
                  </>
                )}
              </div>
            </StatCard>

            <StatCard style={{ minHeight: 88, padding: '12px 14px' }}>
              <StatLabel>Total Permeate Flow</StatLabel>
              <div style={{ marginTop: 10 }}>
                {totalPermeateFlowLoading ? (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Loader size={15} />
                    <H5 color={Colors.gray8} style={{ marginLeft: 10, margin: 0 }}>
                      Loading...
                    </H5>
                  </div>
                ) : (
                  <>
                    <H5 color={Colors.gray8} style={{ margin: '0 0 8px', fontSize: 12 }}>
                      Since membrane change
                    </H5>
                    <StatValue>
                      {totalConsumptionRo.reverseOsmosisTotalPermeateConsumption === 0
                        ? 'N/A'
                        : Math.round(
                            totalConsumptionRo.reverseOsmosisTotalPermeateConsumption,
                          ).toLocaleString()}
                    </StatValue>
                    {totalConsumptionRo.reverseOsmosisTotalPermeateConsumption !== 0 && (
                      <StatUnit>gal</StatUnit>
                    )}
                  </>
                )}
              </div>
            </StatCard>
          </StatsRow>
        </Col>
      </GraphContainer>
    );
  };

  renderMembraneLife = () => {
    const {
      location: {
        ReverseOsmosisFilterHead: { last_membrane_change_date },
      },
    } = this.props;

    return (
      <BG>
        <GraphContainer>
          <Row>
            <Col lg={50} md={50} sm={100} xs={100}>
              <ResponsiveContainer height={90} width="100%">
                <PieChart>
                  <Pie
                    activeIndex={0}
                    activeShape={this.renderActiveShape}
                    // data={dataMembraneChange}
                    dataKey="gal"
                    innerRadius={32}
                    outerRadius={44}
                  />
                </PieChart>
              </ResponsiveContainer>
            </Col>
            <Col lg={50} md={50} sm={100} xs={100}>
              <H4 color={Colors.gray}>Membrane Life</H4>
            </Col>
          </Row>
          <Col>
            <H3 textAlign="center" color={Colors.gray} style={{ marginBottom: 0, marginTop: 7 }}>
              Date Last Update: {moment(last_membrane_change_date).format('h:mma MM/DD/YYYY')}
            </H3>
          </Col>
        </GraphContainer>
      </BG>
    );
  };

  renderFilterCartridges = catridgeSelectedObjet => {
    const { carbonCapacity } = this.state;
    const { totalConsumptionRoLoading, totalConsumptionRo } = this.props;

    // Check if we have a valid cartridge with replacement date
    if (catridgeSelectedObjet && catridgeSelectedObjet.last_replaced) {
      // Calculate weeks since filter was replaced
      const lastReplacedMoment = moment(catridgeSelectedObjet.last_replaced);
      const replacedWeeks = moment().diff(lastReplacedMoment, 'weeks');

      // Calculate flow to expire
      const hasCapacityDataError =
        carbonCapacity === 0 && totalConsumptionRo.reverseOsmosisTotalInletConsumption > 0;

      const usedCapacityPercent = hasCapacityDataError
        ? 100 // Assume 100% used if we have a data error
        : carbonCapacity === 0
        ? 0
        : Math.round(
            (totalConsumptionRo.reverseOsmosisTotalInletConsumption * 100) / carbonCapacity,
          );

      // Remaining capacity (for the pie chart)
      const remainingCapacityPercent = 100 - usedCapacityPercent;

      // Check if capacity is exceeded by flow (percentage-based only)
      // Note: Time-based alerts may be added in the future
      const flowExceeded = usedCapacityPercent >= 100;
      const capacityExceeded = flowExceeded;

      // Status based on percentage only
      let healthStatus;
      if (hasCapacityDataError) {
        healthStatus = 'dataError';
      } else if (capacityExceeded) {
        healthStatus = 'critical';
      } else if (remainingCapacityPercent <= 20) {
        healthStatus = 'critical';
      } else if (remainingCapacityPercent <= 40) {
        healthStatus = 'warning';
      } else {
        healthStatus = 'good';
      }

      const healthColor =
        healthStatus === 'dataError'
          ? Colors.gray8
          : healthStatus === 'good'
          ? Colors.green
          : healthStatus === 'warning'
          ? Colors.yellow
          : Colors.red;

      const dataFilterExhaustion = [
        { name: 'used', value: usedCapacityPercent, fill: Colors.gray3 },
        {
          name: 'remaining',
          value: remainingCapacityPercent > 0 ? remainingCapacityPercent : 0,
          fill: healthColor,
        },
      ];

      return (
        <>
          {/* Modified structure for better mobile layout */}
          <Row style={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
            {/* Pie chart - full width on mobile, half width on larger screens */}
            <Col xs={100} sm={50} md={50} lg={50}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  padding: '10px',
                  alignItems: 'center',
                }}
              >
                {/* Pie Chart Container */}
                <div
                  style={{
                    width: '185px',
                    height: '185px',
                    position: 'relative',
                  }}
                >
                  {totalConsumptionRoLoading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                      }}
                    >
                      <Loader size={30} />
                    </div>
                  ) : (
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={dataFilterExhaustion}
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={80}
                          startAngle={90}
                          endAngle={-270}
                          dataKey="value"
                          activeShape={this.renderActiveShape}
                          activeIndex={1}
                        >
                          {dataFilterExhaustion.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.fill} />
                          ))}
                        </Pie>
                      </PieChart>
                    </ResponsiveContainer>
                  )}
                </div>

                {!totalConsumptionRoLoading && (
                  <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <div
                      style={{
                        display: 'inline-block',
                        background: '#f5f5f5',
                        padding: '5px 10px',
                        borderRadius: '4px',
                      }}
                    >
                      {hasCapacityDataError ? (
                        <H5 color={Colors.gray8} style={{ margin: 0, textAlign: 'center' }}>
                          <span style={{ fontWeight: 'bold', color: Colors.gray8 }}>Error</span> in
                          capacity data
                        </H5>
                      ) : (
                        <H5 color={Colors.gray8} style={{ margin: 0, textAlign: 'center' }}>
                          <span
                            style={{
                              fontWeight: 'bold',
                              color: capacityExceeded
                                ? Colors.red
                                : healthColor === Colors.yellow
                                ? '#FFA000'
                                : healthColor,
                            }}
                          >
                            {remainingCapacityPercent}%
                          </span>{' '}
                          capacity remaining
                        </H5>
                      )}
                      <H5
                        color={Colors.gray8}
                        style={{ margin: '5px 0 0 0', textAlign: 'center', fontSize: '11px' }}
                      >
                        {Math.round(totalConsumptionRo.reverseOsmosisTotalInletConsumption)} /{' '}
                        {carbonCapacity || '?'} gal
                      </H5>
                    </div>
                  </div>
                )}
              </div>
            </Col>

            {/* Filter status - full width on mobile, half width on larger screens */}
            <Col xs={100} sm={50} md={50} lg={50}>
              <div
                style={{
                  padding: '10px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
              >
                {totalConsumptionRoLoading ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <Loader size={30} />
                  </div>
                ) : (
                  <>
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginBottom: '12px',
                          borderLeft: `4px solid ${
                            hasCapacityDataError
                              ? Colors.gray8
                              : capacityExceeded
                              ? Colors.red
                              : healthColor === Colors.yellow
                              ? '#FFA500'
                              : healthColor
                          }`,
                          paddingLeft: '10px',
                        }}
                      >
                        <H4 color={Colors.black} weight={500} style={{ margin: 0 }}>
                          Filter Status
                        </H4>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                          marginBottom: '12px',
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <H5 color={Colors.gray8}>Last Replaced:</H5>
                          <H5 color={Colors.black} weight={500}>
                            {moment(catridgeSelectedObjet.last_replaced).format('MMM D, YYYY')}
                          </H5>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <H5 color={Colors.gray8}>Installed For:</H5>
                          <H5 color={Colors.black} weight={500}>
                            {replacedWeeks} weeks
                          </H5>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <H5 color={Colors.gray8}>Capacity Remaining:</H5>
                          <H5
                            color={
                              hasCapacityDataError
                                ? Colors.gray8
                                : flowExceeded
                                ? Colors.red
                                : Colors.black
                            }
                            weight={500}
                          >
                            {hasCapacityDataError
                              ? `${Math.round(
                                  totalConsumptionRo.reverseOsmosisTotalInletConsumption,
                                )} gal`
                              : `${remainingCapacityPercent}%`}
                          </H5>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        background: hasCapacityDataError
                          ? '#F5F5F5'
                          : capacityExceeded
                          ? '#FFEBEE'
                          : healthColor === Colors.yellow
                          ? '#FFF8E1'
                          : healthColor === Colors.green
                          ? '#E8F5E9'
                          : '#FFEBEE',
                        padding: '10px',
                        borderRadius: '4px',
                        textAlign: 'center',
                        marginTop: '15px', // Add margin for mobile view spacing
                      }}
                    >
                      <H3
                        color={
                          hasCapacityDataError
                            ? Colors.gray8
                            : capacityExceeded
                            ? Colors.red
                            : healthColor === Colors.yellow
                            ? '#FFA000'
                            : healthColor
                        }
                        weight={600}
                        style={{ margin: 0 }}
                      >
                        {hasCapacityDataError
                          ? 'Data Error - Contact Support'
                          : capacityExceeded
                          ? 'Please Replace Filters'
                          : `${remainingCapacityPercent}% capacity remaining`}
                      </H3>
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>

          {/* Filter Status Boxes Row */}
          {!totalConsumptionRoLoading && (
            <Row style={{ marginTop: 30 }}>
              <Col xs={100} md={100} sm={100} lg={100}>
                <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                    whiteSpace: 'nowrap',
                    paddingBottom: '10px' /* Add some padding for scrollbar */,
                    WebkitOverflowScrolling: 'touch' /* For smooth scrolling on iOS */,
                    msOverflowStyle: '-ms-autohiding-scrollbar' /* Hide scrollbar in IE */,
                  }}
                >
                  <div style={{ display: 'inline-flex', minWidth: '100%' }}>
                    {(() => {
                      // Extract FlowMeterOfROFilters from props
                      const {
                        location: {
                          ReverseOsmosisFilterHead: { FlowMeterOfROFilters },
                        },
                      } = this.props;

                      // Return a column for each filter
                      return FlowMeterOfROFilters.map((filter, index) => {
                        const { SpotsReverseOsmosisFilter } = filter;
                        const { Catridge, position } = SpotsReverseOsmosisFilter;
                        const isSediment = Catridge?.sediment;

                        // Determine status icon based on health status
                        const iconComponent =
                          capacityExceeded || healthStatus === 'critical' ? (
                            <Icon name="exclamation-circle" color={Colors.red} fontSize={30} />
                          ) : healthStatus === 'warning' && index === 1 ? ( // Show warning only for second filter typically
                            <Icon name="exclamation-circle" color="#FFA000" fontSize={30} />
                          ) : (
                            <Icon name="check-circle" color={Colors.green} fontSize={30} />
                          );

                        return (
                          <div
                            key={filter.id}
                            style={{
                              display: 'inline-block',
                              width: '200px' /* Fixed width for each filter box */,
                              padding: '0 4px',
                              marginRight: '8px',
                            }}
                          >
                            <div
                              style={{
                                minHeight: 95,
                                height: 120 /* Add fixed height */,
                                width: '100%',
                                padding: '15px',
                                backgroundColor: '#f8fbff',
                                borderRadius: '8px',
                                border: '1px solid #edf2f7',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                position: 'relative',
                                overflow: 'hidden' /* Prevent content overflow */,
                              }}
                            >
                              {isSediment && (
                                <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                                  <a
                                    data-tooltip-id={`sediment-tooltip-${filter.id}`}
                                    data-tooltip-content="Sediment filters (SED) do not have a chlorine reduction gallon capacity."
                                  >
                                    <Icon name="info-circle" color={Colors.gray8} fontSize={14} />
                                  </a>
                                  <TooltipReact
                                    id={`sediment-tooltip-${filter.id}`}
                                    place="top"
                                    positionStrategy="fixed"
                                  />{' '}
                                </div>
                              )}
                              <div style={{ marginRight: '15px' }}>{iconComponent}</div>
                              <div>
                                <H4
                                  style={{
                                    margin: 0,
                                    fontSize: '16px',
                                    fontWeight: 500,
                                    color: '#333',
                                    marginBottom: 5,
                                    textAlign: 'left',
                                    whiteSpace: 'normal',
                                  }}
                                >
                                  {Catridge?.name || `Filter ${index + 1}`}
                                </H4>
                                <H5
                                  style={{
                                    margin: 0,
                                    color: Colors.gray8,
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    whiteSpace: 'normal',
                                  }}
                                >
                                  {position || `Position ${index + 1}`}
                                </H5>
                              </div>
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </>
      );
    }

    return (
      <div
        style={{
          padding: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '200px',
          background: '#f9f9f9',
          borderRadius: '4px',
        }}
      >
        <ListEmpty message="The cartridges have not been replaced yet" />
      </div>
    );
  };

  switchModalMembrane = value => {
    this.setState({ modalMembrane: value });
  };

  switchModalCartridges = value => {
    this.setState({ modalCartridges: value });
  };

  changeMembrane = () => {
    const {
      changeMembrane,
      location: { ReverseOsmosisFilterHead },
    } = this.props;
    const id = ReverseOsmosisFilterHead.FlowMeterOfROFilters[0].reverse_osmosis_filter_head_id;
    const { membraneChangeDate } = this.state;
    const membraneChangeDateUTC = moment(membraneChangeDate)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');

    changeMembrane(id, membraneChangeDateUTC);
  };

  downloadPDF = () => {
    const {
      totalGaloonsChart,
      averageChart,
      wasteChart,
      downloadPDF,
      datePickerFromConsumption,
      datePickerToConsumption,
      datePickerFromTds,
      datePickerToTds,
      datePickerFromWaste,
      datePickerToWaste,
      exhaustionChart,
      catridgeSelectedObjet,
      carbonCapacity,
    } = this.state;

    const {
      location,
      allAlerts,
      reverseOsmosisLastHourTds,
      reverseOsmosisCurrentState,
      reverseOsmosisConsumption,
      totalConsumptionRo,
      reverseOsmosisCurrentBypass,
      reverseOsmosisCurrentPressure: { inletPressure, tankPressure, systemPressure },
      reverseOsmosisCurrentTemperature,
    } = this.props;

    if (downloadPDF) {
      return (
        <PDFDownloadLink
          document={
            <ReportRO
              totalGaloonsChart={totalGaloonsChart}
              averageChart={averageChart}
              wasteChart={wasteChart}
              datePickerFromConsumption={datePickerFromConsumption}
              datePickerToConsumption={datePickerToConsumption}
              datePickerFromTds={datePickerFromTds}
              datePickerToTds={datePickerToTds}
              datePickerFromWaste={datePickerFromWaste}
              datePickerToWaste={datePickerToWaste}
              allAlerts={allAlerts}
              location={location}
              reverseOsmosisCurrentState={reverseOsmosisCurrentState}
              reverseOsmosisLastHourTds={reverseOsmosisLastHourTds}
              carbonCapacity={carbonCapacity}
              reverseOsmosisConsumption={reverseOsmosisConsumption}
              catridgeSelectedObjet={catridgeSelectedObjet}
              exhaustionChart={exhaustionChart}
              totalConsumptionRo={totalConsumptionRo}
              reverseOsmosisCurrentBypass={reverseOsmosisCurrentBypass}
              inletPressure={inletPressure}
              tankPressure={tankPressure}
              systemPressure={systemPressure}
              reverseOsmosisCurrentTemperature={reverseOsmosisCurrentTemperature}
            />
          }
          fileName="ReportRO.pdf"
        >
          {({ loading }) => (
            <H4
              color={Colors.lightBlue}
              style={{ cursor: 'pointer' }}
              onClick={() => this.setState({ generatePDF: false, downloadPDF: false })}
            >
              <Icon
                name={loading ? 'far fa-spinner' : 'far fa-file-download'}
                color={Colors.lightBlue}
                customStyle={{ marginRight: '5px' }}
              />
              {loading ? 'Loading' : 'Download'} Report
            </H4>
          )}
        </PDFDownloadLink>
      );
    }
    return (
      <Row>
        <Loader size={35} block />
        <H4 color={Colors.lightBlue} marginTop={5}>
          Generating PDF ...
        </H4>
      </Row>
    );
  };

  render() {
    const {
      location: {
        id: location_id,
        ReverseOsmosisFilterHead,
        Account: {
          Brand: {
            out_of_compliance,
            near_compliance_1_end,
            in_compliance_end,
            near_compliance_2_end,
            out_of_compliance_2_end,
          },
        },
      },
      renderInstructionsModal,
      reverseOsmosisTds,
      reverseOsmosisLastHourTds,
      reverseOsmosisWaste,
      reverseOsmosisTdsLoading,
      reverseOsmosisWasteLoading,
      setDeviceId,
      reverseOsmosisCurrentPressure: { inletPressure, tankPressure, systemPressure },
      reverseOsmosisCurrentPressureLoading,
      reverseOsmosisCurrentBypass,
      reverseOsmosisCurrentBypassLoading,
    } = this.props;

    const {
      cartridgesChangeDate,
      membraneChangeDate,
      modalMembrane,
      modalCartridges,
      catridgeSelectedObjet,
      datePickerFromConsumption,
      datePickerToConsumption,
      modalDatePickerConsumption,
      modalDatePickerWaste,
      modalDatePickerTds,
      datePickerFromTds,
      datePickerToTds,
      datePickerFromWaste,
      datePickerToWaste,
      consumptionInterval,
      bypassInterval,
      tdsInterval,
      wasteInterval,
      modalDatePickerCsv,
      datePickerFromCsv,
      datePickerToCsv,
      csvType,
      new_device_id,
      modalDeviceId,
      modalDatePickerReport,
      datePickerFromReport,
      datePickerToReport,
      modalDatePickerBypass,
      modalBypass,
      datePickerFromBypass,
      datePickerToBypass,
    } = this.state;

    const {
      FlowMeterOfROFilters,
      MembraneChanges: membranesReplaced,
      ReverseOsmosisFilterConfiguration,
      device_id,
      installed_date,
      last_membrane_change_date,
    } = ReverseOsmosisFilterHead;
    const { ReverseOsmosisFilterInstallSteps } = ReverseOsmosisFilterConfiguration;
    const cartridgesOfROChanges = FlowMeterOfROFilters[0].CartridgesOfROChanges;
    const bypassStatus =
      !reverseOsmosisCurrentBypassLoading &&
      reverseOsmosisCurrentBypass != null &&
      reverseOsmosisCurrentBypass !== 0;

    const tdsReferenceAreas = [
      { y1: 0, y2: out_of_compliance, fill: Colors.red },
      { y1: out_of_compliance, y2: near_compliance_1_end, fill: Colors.yellow },
      { y1: near_compliance_1_end, y2: in_compliance_end, fill: Colors.green },
      { y1: in_compliance_end, y2: near_compliance_2_end, fill: Colors.yellow },
      { y1: near_compliance_2_end, y2: out_of_compliance_2_end, fill: Colors.red },
    ];

    const wasteReferenceAreas = [
      { y1: 30, y2: 70, fill: Colors.green },
      { y1: 10, y2: 30, fill: Colors.yellow },
      { y1: 70, y2: 90, fill: Colors.yellow },
      { y1: 0, y2: 10, fill: Colors.red },
      { y1: 90, y2: 100, fill: Colors.red },
    ];

    return (
      <Container
        style={{
          overflowX: 'hidden',
        }}
      >
        {/* Quick Stats Row */}
        <Row style={{ marginTop: 24, marginBottom: 24 }}>
          <Col lg={25} md={50} sm={50} xs={100} style={{ padding: '0 8px', marginBottom: 16 }}>
            <QuickStats
              icon="weight"
              iconBgColor="rgba(100, 161, 242, 0.1)"
              title="Inlet Pressure"
              value={inletPressure !== null ? Math.round(inletPressure) : null}
              unit="psi"
              isLoading={reverseOsmosisCurrentPressureLoading}
              isInstalled={!!device_id}
            />
          </Col>
          <Col lg={25} md={50} sm={50} xs={100} style={{ padding: '0 8px', marginBottom: 16 }}>
            <QuickStats
              icon="vials"
              iconBgColor="rgba(252, 186, 3, 0.1)"
              title="Tank Pressure"
              value={tankPressure !== null ? Math.round(tankPressure) : null}
              unit="psi"
              isLoading={reverseOsmosisCurrentPressureLoading}
              isInstalled={!!device_id}
            />
          </Col>
          <Col lg={25} md={50} sm={50} xs={100} style={{ padding: '0 8px', marginBottom: 16 }}>
            <QuickStats
              icon="tachometer-alt"
              iconBgColor="rgba(39, 174, 96, 0.1)"
              title="System Pressure"
              value={systemPressure !== null ? Math.round(systemPressure) : null}
              unit="psi"
              isLoading={reverseOsmosisCurrentPressureLoading}
              isInstalled={!!device_id}
            />
          </Col>
          <Col lg={25} md={50} sm={50} xs={100} style={{ padding: '0 8px', marginBottom: 16 }}>
            <QuickStats
              icon="exchange-alt"
              iconBgColor={bypassStatus ? 'rgba(235, 87, 87, 0.1)' : 'rgba(39, 174, 96, 0.1)'}
              iconColor={bypassStatus ? Colors.red : Colors.green}
              title="Bypass Status"
              value={
                !reverseOsmosisCurrentBypassLoading && reverseOsmosisCurrentBypass != null
                  ? reverseOsmosisCurrentBypass === 0
                    ? 'Off'
                    : 'On'
                  : null
              }
              valueColor={bypassStatus ? Colors.red : Colors.green}
              isLoading={reverseOsmosisCurrentBypassLoading}
              isInstalled={!!device_id}
              onClick={() => {
                this.switchModal('modalBypass');
                this.calculeReverseOsmosisBypass();
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10, alignItems: 'stretch' }}>
          <Col lg={50} md={100} sm={100} xs={100} style={{ display: 'flex' }}>
            <BG style={{ flex: 1, width: '100%' }}>{this.renderReverseOsmosisConsumptions()}</BG>
          </Col>

          <Col lg={50} md={100} sm={100} xs={100} style={{ display: 'flex' }}>
            <BG style={{ flex: 1, width: '100%' }}>
              <GraphContainer
                height={RO_PANEL_HEIGHT}
                style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
              >
                <Col style={{ flexGrow: 1 }}>
                  {/* RO Filter Cartridges Header Row */}
                  <Row
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ marginBottom: 20 }}
                  >
                    <H2
                      style={{
                        margin: 0,
                        fontWeight: 600,
                        fontSize: '24px',
                        fontFamily: 'Inter, sans-serif',
                      }}
                    >
                      RO Filter Cartridges
                    </H2>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <div
                        style={{
                          backgroundColor: '#1498CB',
                          borderRadius: '5px',
                          padding: '8px 16px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s ease',
                        }}
                        onClick={() => {
                          this.setState({ membraneChangeDate: new Date() });
                          this.switchModalMembrane(!modalMembrane);
                        }}
                        onMouseOver={e => (e.currentTarget.style.backgroundColor = '#0e80ad')}
                        onMouseOut={e => (e.currentTarget.style.backgroundColor = '#1498CB')}
                        onFocus={e => (e.currentTarget.style.backgroundColor = '#0e80ad')}
                        onBlur={e => (e.currentTarget.style.backgroundColor = '#1498CB')}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            this.setState({ membraneChangeDate: new Date() });
                            this.switchModalMembrane(!modalMembrane);
                          }
                        }}
                      >
                        <Icon
                          name="far fa-exchange-alt"
                          color="#FFFFFF"
                          fontSize={16}
                          customStyle={{ marginRight: '8px' }}
                        />
                        <H5 color="#FFFFFF" style={{ margin: 0, cursor: 'pointer' }}>
                          Change Membrane
                        </H5>
                      </div>

                      <div
                        style={{
                          backgroundColor: '#1498CB',
                          borderRadius: '5px',
                          padding: '8px 16px',
                          display: 'inline-flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          transition: 'background-color 0.2s ease',
                        }}
                        onClick={() => {
                          this.setState({ cartridgesChangeDate: new Date() });
                          this.switchModalCartridges(!modalCartridges);
                        }}
                        onMouseOver={e => (e.currentTarget.style.backgroundColor = '#0e80ad')}
                        onMouseOut={e => (e.currentTarget.style.backgroundColor = '#1498CB')}
                        onFocus={e => (e.currentTarget.style.backgroundColor = '#0e80ad')}
                        onBlur={e => (e.currentTarget.style.backgroundColor = '#1498CB')}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            this.setState({ cartridgesChangeDate: new Date() });
                            this.switchModalCartridges(!modalCartridges);
                          }
                        }}
                      >
                        <Icon
                          name="sync"
                          color="#FFFFFF"
                          fontSize={16}
                          customStyle={{ marginRight: '8px' }}
                        />
                        <H5 color="#FFFFFF" style={{ margin: 0, cursor: 'pointer' }}>
                          Replace Cartridges
                        </H5>
                      </div>
                    </div>
                  </Row>

                  {/* Filter Cartridges Content */}
                  <Row>
                    <Col lg={100} md={100} sm={100} xs={100} style={{ marginBottom: 20 }}>
                      {this.renderFilterCartridges(catridgeSelectedObjet)}
                    </Col>
                  </Row>
                </Col>
              </GraphContainer>
            </BG>
          </Col>
        </Row>
        <Row>
          <Col lg={100} md={100} sm={100} xs={100} justifyContent="center">
            <BG>
              <GraphContainer height={360}>
                <Col style={{ width: '100%', alignItems: 'stretch' }}>
                  <Row
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ width: '100%', marginBottom: 12 }}
                  >
                    <div>
                      <H2
                        style={{
                          margin: 0,
                          fontWeight: 600,
                          fontSize: '24px',
                          fontFamily: 'Inter, sans-serif',
                        }}
                      >
                        Average TDS
                      </H2>
                      <H5 style={{ color: Colors.gray, margin: '8px 0 0' }}>
                        Past hour:{' '}
                        <span style={{ color: Colors.blue }}>
                          {reverseOsmosisLastHourTds || 'N/A'} ppm
                        </span>
                      </H5>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <IntervalBadge>{getIntervalLabel(tdsInterval)}</IntervalBadge>
                      <DateRangeButton
                        type="button"
                        onClick={() => this.switchModal('modalDatePickerTds')}
                      >
                        {moment(datePickerFromTds).format('MM/DD/YYYY')} –{' '}
                        {moment(datePickerToTds).format('MM/DD/YYYY')}
                        <Icon name="calendar-alt" color={Colors.lightBlue} fontSize={14} />
                      </DateRangeButton>
                    </div>
                  </Row>
                  <ChartSection style={{ alignItems: 'stretch', width: '100%' }}>
                    {!device_id ? (
                      <Col style={{ height: 260 }} justifyContent="center">
                        <ListEmpty message="Installation Not Complete" />
                      </Col>
                    ) : (
                      <ChartViewportFull style={{ height: 260 }}>
                        <RoMetricLineChart
                          id="averageChart"
                          data={reverseOsmosisTds}
                          loading={reverseOsmosisTdsLoading}
                          valueLabel="PPM"
                          referenceAreas={tdsReferenceAreas}
                        />
                      </ChartViewportFull>
                    )}
                  </ChartSection>
                </Col>
              </GraphContainer>
            </BG>
          </Col>
        </Row>
        <Row alignItems="end">
          <Col lg={100} md={100} sm={100} xs={100} justifyContent="center">
            <BG>
              <GraphContainer height={360}>
                <Col style={{ width: '100%', alignItems: 'stretch' }}>
                  <Row
                    justifyContent="space-between"
                    alignItems="center"
                    style={{ width: '100%', marginBottom: 12 }}
                  >
                    <H2
                      style={{
                        margin: 0,
                        fontWeight: 600,
                        fontSize: '24px',
                        fontFamily: 'Inter, sans-serif',
                      }}
                    >
                      Waste Water Percentage
                    </H2>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <IntervalBadge>{getIntervalLabel(wasteInterval)}</IntervalBadge>
                      <DateRangeButton
                        type="button"
                        onClick={() => this.switchModal('modalDatePickerWaste')}
                      >
                        {moment(datePickerFromWaste).format('MM/DD/YYYY')} –{' '}
                        {moment(datePickerToWaste).format('MM/DD/YYYY')}
                        <Icon name="calendar-alt" color={Colors.lightBlue} fontSize={14} />
                      </DateRangeButton>
                    </div>
                  </Row>
                  <ChartSection style={{ alignItems: 'stretch', width: '100%' }}>
                    {!device_id ? (
                      <Col style={{ height: 260 }} justifyContent="center">
                        <ListEmpty message="Installation Not Complete" />
                      </Col>
                    ) : (
                      <ChartViewportFull style={{ height: 260 }}>
                        <RoMetricLineChart
                          id="wasteChart"
                          data={reverseOsmosisWaste}
                          loading={reverseOsmosisWasteLoading}
                          valueLabel="%"
                          referenceAreas={wasteReferenceAreas}
                        />
                      </ChartViewportFull>
                    )}
                  </ChartSection>
                </Col>
              </GraphContainer>
            </BG>
          </Col>
        </Row>
        <Modal
          title="Membrane change"
          onClose={() => {
            this.setState({ membraneChangeDate: '' });
            this.switchModalMembrane(!modalMembrane);
          }}
          isVisible={modalMembrane}
          size="small"
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <H4 color={Colors.gray4}>Change date</H4>
            <DatePickerComponent
              minDate={moment(installed_date).toDate()}
              date={membraneChangeDate}
              onChange={value => this.handleDate(value, 'membraneChangeDate')}
              style={{ width: '100%' }}
            />
          </div>

          <Row
            style={{
              marginTop: 10,
              marginBottom: 10,
              gap: 10,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <ButtonText
              text="Cancel"
              theme="secondary"
              type="submit"
              onClick={() => {
                this.setState({ membraneChangeDate: '' });
                this.switchModalMembrane(!modalMembrane);
              }}
            />
            <ButtonText
              text="Confirm"
              theme="primary"
              type="submit"
              disabled={!membraneChangeDate}
              onClick={() => {
                this.changeMembrane();
                this.setState({ membraneChangeDate: '' });
                this.switchModalMembrane(!modalMembrane);
              }}
            />
          </Row>

          {membranesReplaced && membranesReplaced.length > 0 && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: 5,
                }}
              >
                <H2 color={Colors.blue}>Change History</H2>
              </div>

              <Row style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                {membranesReplaced.map(membrane => (
                  <Col
                    key={membrane.id}
                    style={{ display: 'flex', alignItems: 'start', width: '70%' }}
                  >
                    <LineGray />
                    <Row
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: 5,
                        width: '100%',
                      }}
                    >
                      <H5 color={Colors.blue}>
                        {moment(membrane.created_at).format('MM/DD/YYYY')}
                      </H5>
                      <H5 style={{ marginLeft: 3 }} color={Colors.blue}>
                        {membrane.User ? membrane.User.email : 'Unknown'}
                      </H5>
                    </Row>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Modal>

        <Modal
          title="Replace Cartridges"
          onClose={() => this.switchModalCartridges(!modalCartridges)}
          isVisible={modalCartridges}
          size="small"
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <H4 color={Colors.gray4}>Changed date</H4>
            <DatePickerComponent
              minDate={moment(installed_date).toDate()}
              date={cartridgesChangeDate}
              onChange={value => this.handleDate(value, 'cartridgesChangeDate')}
              style={{ width: '100%' }}
            />
          </div>
          <Row
            style={{
              marginTop: 30,
              marginBottom: 10,
              gap: 10,
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <ButtonText
              text="Cancel"
              theme="secondary"
              type="submit"
              onClick={() => this.switchModalCartridges(!modalCartridges)}
            />
            <ButtonText
              text="Confirm"
              theme="primary"
              type="submit"
              disabled={!cartridgesChangeDate}
              onClick={() => {
                this.replaceReverseOsmosisCartridgesFunc();
                this.switchModalCartridges(!modalCartridges);
              }}
            />
          </Row>
          {cartridgesOfROChanges && cartridgesOfROChanges.length > 0 && (
            <>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: 5,
                }}
              >
                <H2 color={Colors.blue}>Change History</H2>
              </div>
              <Row style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                {cartridgesOfROChanges.map(cartridge => (
                  <Col
                    key={cartridge.id}
                    style={{ display: 'flex', alignItems: 'start', width: '70%' }}
                  >
                    <LineGray />
                    <Row
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: 5,
                        width: '100%',
                      }}
                    >
                      <H5 color={Colors.blue}>
                        {moment(cartridge.created_at).format('MM/DD/YYYY')}
                      </H5>
                      <H5 style={{ marginLeft: 3 }} color={Colors.blue}>
                        {cartridge.User ? cartridge.User.email : 'Unknown'}
                      </H5>
                    </Row>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Modal>

        <ModalDatePicker
          minDate={moment(last_membrane_change_date).toDate()}
          isVisible={modalDatePickerConsumption}
          handleDateFrom={value => this.handleDate(value, 'datePickerFromConsumption')}
          handleDateTo={value => this.handleDate(value, 'datePickerToConsumption')}
          switchModal={() => this.switchModal('modalDatePickerConsumption')}
          dateFrom={datePickerFromConsumption}
          dateTo={datePickerToConsumption}
          interval={consumptionInterval}
          intervalOptions={CONSUMPTION_INTERVAL_GROUPS}
          onIntervalChange={value => this.setState({ consumptionInterval: value })}
          saveChanges={() => {
            this.switchModal('modalDatePickerConsumption');
            this.calculeReverseOsmosisConsumption();
          }}
        />
        <ModalCsvFiles
          minDate={moment(installed_date).toDate()}
          isVisible={modalDatePickerCsv}
          handleDateFrom={value => this.handleDate(value, 'datePickerFromCsv')}
          handleDateTo={value => this.handleDate(value, 'datePickerToCsv')}
          switchModal={() => this.switchModal('modalDatePickerCsv')}
          dateFrom={datePickerFromCsv}
          dateTo={datePickerToCsv}
          changeCsvType={this.changeCsvType}
          csvType={csvType}
          userEmail={this.props.userEmail}
          saveChanges={email => {
            this.switchModal('modalDatePickerCsv');
            this.generateReverseOsmosisCsv(email);
          }}
        />
        <ModalDatePicker
          minDate={moment(installed_date).toDate()}
          isVisible={modalDatePickerTds}
          handleDateFrom={value => this.handleDate(value, 'datePickerFromTds')}
          handleDateTo={value => this.handleDate(value, 'datePickerToTds')}
          switchModal={() => this.switchModal('modalDatePickerTds')}
          dateFrom={datePickerFromTds}
          dateTo={datePickerToTds}
          interval={tdsInterval}
          intervalOptions={CONSUMPTION_INTERVAL_GROUPS}
          onIntervalChange={value => this.setState({ tdsInterval: value })}
          saveChanges={() => {
            this.switchModal('modalDatePickerTds');
            this.calculeReverseOsmosisTds();
          }}
        />
        <ModalDatePicker
          minDate={moment(installed_date).toDate()}
          isVisible={modalDatePickerWaste}
          handleDateFrom={value => this.handleDate(value, 'datePickerFromWaste')}
          handleDateTo={value => this.handleDate(value, 'datePickerToWaste')}
          switchModal={() => this.switchModal('modalDatePickerWaste')}
          dateFrom={datePickerFromWaste}
          dateTo={datePickerToWaste}
          interval={wasteInterval}
          intervalOptions={CONSUMPTION_INTERVAL_GROUPS}
          onIntervalChange={value => this.setState({ wasteInterval: value })}
          saveChanges={() => {
            this.switchModal('modalDatePickerWaste');
            this.calculeReverseOsmosisWaste();
          }}
        />
        {this.renderConfigurationModal()}
        <Modal
          title="Update Device ID (Serial Number)"
          onClose={() => this.switchModal('modalDeviceId')}
          isVisible={modalDeviceId}
          size="small"
        >
          <Row>
            <Col>
              <Input
                placeholder="Device ID"
                value={new_device_id}
                onChange={this.handleChangeDeviceId}
                style={{ marginBottom: '20px' }}
              />
              <ButtonText
                text="Update"
                theme="primary"
                onClick={() =>
                  setDeviceId({ type: 'reverse-osmosis', device_id: new_device_id, location_id })
                }
              />
            </Col>
          </Row>
        </Modal>
        <ModalDatePicker
          minDate={moment(installed_date).toDate()}
          isVisible={modalDatePickerReport}
          handleDateFrom={value => this.handleDate(value, 'datePickerFromReport')}
          handleDateTo={value => this.handleDate(value, 'datePickerToReport')}
          switchModal={() => this.switchModal('modalDatePickerReport')}
          dateFrom={datePickerFromReport}
          dateTo={datePickerToReport}
          saveChanges={() => {
            this.switchModal('modalDatePickerReport');
            this.generateReport();
          }}
        />

        <ModalDatePicker
          minDate={moment(installed_date).toDate()}
          isVisible={modalDatePickerBypass}
          handleDateFrom={value => this.handleDate(value, 'datePickerFromBypass')}
          handleDateTo={value => this.handleDate(value, 'datePickerToBypass')}
          switchModal={() => this.switchModal('modalDatePickerBypass')}
          dateFrom={datePickerFromBypass}
          dateTo={datePickerToBypass}
          interval={bypassInterval}
          intervalOptions={CONSUMPTION_INTERVAL_GROUPS}
          onIntervalChange={value => this.setState({ bypassInterval: value })}
          saveChanges={() => {
            this.switchModal('modalDatePickerBypass');
            this.calculeReverseOsmosisBypass();
          }}
        />

        <Modal
          title="Bypass Flow"
          onClose={() => this.switchModal('modalBypass')}
          isVisible={modalBypass}
          size="large"
        >
          {this.renderBypassConsumptions()}
        </Modal>

        {renderInstructionsModal(
          this.state.modalViewInstructions,
          () => this.switchModal('modalViewInstructions'),
          ReverseOsmosisFilterInstallSteps,
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    reverseOsmosisCurrentState: state.locations.reverseOsmosisCurrentState,
    reverseOsmosisConsumption: state.locations.reverseOsmosisConsumption,
    reverseOsmosisConsumptionLoading: state.locations.reverseOsmosisConsumptionLoading,
    totalConsumptionReverseOsmosisLoading: state.locations.totalConsumptionReverseOsmosisLoading,
    reverseOsmosisCurrentStateLoading: state.locations.reverseOsmosisCurrentStateLoading,
    reverseOsmosisTotalConsumption: state.locations.reverseOsmosisTotalConsumption,
    reverseOsmosisWaste: state.locations.reverseOsmosisWaste.waste,
    reverseOsmosisWasteLoading: state.locations.reverseOsmosisWasteLoading,
    reverseOsmosisTds: state.locations.reverseOsmosisTds.tds,
    reverseOsmosisLastHourTds: state.locations.reverseOsmosisTds.tdsLastHour,
    reverseOsmosisTdsLoading: state.locations.reverseOsmosisTdsLoading,
    totalConsumptionRoLoading: state.locations.totalConsumptionRoLoading,
    totalConsumptionRo: state.locations.totalConsumptionRo,
    cartridgeTotalConsumptionRo: state.locations.cartridgeTotalConsumptionRo,
    cartridgeTotalConsumptionRoLoading: state.locations.cartridgeTotalConsumptionRoLoading,
    ro_for_pfd: state.locations.ro_for_pfd,
    role_id: state.auth.profile.role_id,
    userEmail: state.auth.profile?.email,
    reverseOsmosisBypass: state.locations.reverseOsmosisBypass,
    reverseOsmosisBypassLoading: state.locations.reverseOsmosisBypassLoading,
    reverseOsmosisCurrentBypass: state.locations.reverseOsmosisCurrentBypass,
    reverseOsmosisCurrentBypassLoading: state.locations.reverseOsmosisCurrentBypassLoading,
    reverseOsmosisCurrentPressure: state.locations.reverseOsmosisCurrentPressure,
    reverseOsmosisCurrentPressureLoading: state.locations.reverseOsmosisCurrentPressureLoading,
    reverseOsmosisCurrentTemperature: state.locations.reverseOsmosisCurrentTemperature,
    reverseOsmosisCurrentTemperatureLoading:
      state.locations.reverseOsmosisCurrentTemperatureLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    reverseOsmosisSetInitialState: () => dispatch(reverseOsmosisSetInitialState()),
    changeMembrane: (id, new_date) => dispatch(changeMembranes({ id, new_date })),
    getReverseOsmosisCurrentState: serialNumber =>
      dispatch(getReverseOsmosisCurrentState(serialNumber)),
    getReverseOsmosisConsumption: params => dispatch(getReverseOsmosisConsumption(params)),
    getReverseOsmosisTds: params => dispatch(getReverseOsmosisTds(params)),
    getReverseOsmosisWaste: params => dispatch(getReverseOsmosisWaste(params)),
    getTotalConsumptionReverseOsmosis: params =>
      dispatch(getTotalConsumptionReverseOsmosis(params)),
    generateReverseOsmosisCsv: params => dispatch(generateReverseOsmosisCsv(params)),
    getTotalConsumptionRo: params => dispatch(getTotalConsumptionRo(params)),
    getTotalConsumptionCartridgeRo: params => dispatch(getTotalConsumptionCartridgeRo(params)),
    replaceReverseOsmosisCartridges: params => dispatch(replaceReverseOsmosisCartridges(params)),
    getReverseOsmosisBypass: params => dispatch(getReverseOsmosisBypass(params)),
    getReverseOsmosisCurrentBypass: serialNumber =>
      dispatch(getReverseOsmosisCurrentBypass(serialNumber)),
    getReverseOsmosisCurrentPressure: params => dispatch(getReverseOsmosisCurrentPressure(params)),
    getReverseOsmosisCurrentTemperature: params =>
      dispatch(getReverseOsmosisCurrentTemperature(params)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(RO);

RO.propTypes = {
  allAlerts: PropTypes.array,
  changeMembrane: PropTypes.func,
  data: PropTypes.array,
  device_id: PropTypes.string,
  fetchAllAlerts: PropTypes.func,
  generateReverseOsmosisCsv: PropTypes.func,
  getReverseOsmosisBypass: PropTypes.func,
  getReverseOsmosisConsumption: PropTypes.func,
  getReverseOsmosisCurrentBypass: PropTypes.func,
  getReverseOsmosisCurrentPressure: PropTypes.func,
  getReverseOsmosisCurrentState: PropTypes.func,
  getReverseOsmosisCurrentTemperature: PropTypes.func,
  getReverseOsmosisTds: PropTypes.func,
  getReverseOsmosisWaste: PropTypes.func,
  getTotalConsumptionCartridgeRo: PropTypes.func,
  getTotalConsumptionRo: PropTypes.func,
  location: PropTypes.object,
  renderInstructionsModal: PropTypes.func,
  replaceReverseOsmosisCartridges: PropTypes.func,
  reverseOsmosisBypass: PropTypes.array,
  reverseOsmosisBypassLoading: PropTypes.bool,
  reverseOsmosisConsumption: PropTypes.array,
  reverseOsmosisConsumptionLoading: PropTypes.bool,
  reverseOsmosisCurrentBypass: PropTypes.object,
  reverseOsmosisCurrentBypassLoading: PropTypes.bool,
  reverseOsmosisCurrentPressure: PropTypes.object,
  reverseOsmosisCurrentPressureLoading: PropTypes.bool,
  reverseOsmosisCurrentState: PropTypes.object,
  reverseOsmosisCurrentStateLoading: PropTypes.bool,
  reverseOsmosisCurrentTemperature: PropTypes.number,
  reverseOsmosisLastHourTds: PropTypes.number,
  reverseOsmosisSetInitialState: PropTypes.func,
  reverseOsmosisTds: PropTypes.array,
  reverseOsmosisTdsLoading: PropTypes.bool,
  reverseOsmosisWaste: PropTypes.array,
  reverseOsmosisWasteLoading: PropTypes.bool,
  ro_for_pfd: PropTypes.bool,
  setDeviceDisconnected: PropTypes.func,
  setDeviceId: PropTypes.func,
  setLastUpdatedLoading: PropTypes.func,
  setTdsLoading: PropTypes.func,
  totalConsumptionRo: PropTypes.object,
  totalConsumptionRoLoading: PropTypes.bool,
  updateLastUpdated: PropTypes.func,
  updateTdsValue: PropTypes.func,
  userEmail: PropTypes.string,
};
